// Types
export const Types = {
  GET_DOMAINS: 'GET_DOMAINS',
  GET_PAGED_DOMAINS: 'GET_PAGED_DOMAINS',
  GET_DOMAIN: 'GET_DOMAIN',
  GET_USER_DOMAINS_AVAILABLE: 'GET_USER_DOMAINS_AVAILABLE',
  CREATE_DOMAINS: 'CREATE_DOMAINS',
  UPDATE_DOMAIN: 'UPDATE_DOMAIN',
  DELETE_DOMAIN: 'DELETE_DOMAIN',
  SET_LOADING: "SET_LOADING_DOMAIN",
};

// Reducer
const initialState = {
  domains: null,
  pagedDomains: null,
  domain: null,
  catalogDomainsAvailable: null,

  loading: false,
};

const Domains = (state=initialState, action) => {
  switch (action.type) {
    case Types.GET_DOMAINS:
      return {
        ...state,
        domains: action.payload,
        loading: false,
      }
    case Types.GET_PAGED_DOMAINS:
      return {
        ...state,
        pagedDomains: action.payload,
        loading: false,
      }
    case Types.GET_DOMAIN:
        return {
          ...state,
          domain: action.payload,
          loading: false,
        }
    case Types.CREATE_DOMAINS:
      return {
        ...state,
        // domain: action.payload,
        loading: false,
      }
    case Types.UPDATE_DOMAIN:
      return {
        ...state,
        // domain: action.payload,
        loading: false,
      }
    case Types.DELETE_DOMAIN:
      return {
        ...state,
        // domain: action.payload,
        loading: false,
      }
    case Types.GET_USER_DOMAINS_AVAILABLE:
      return {
        ...state,
        catalogDomainsAvailable: action.payload,
        loading: false,
      }
    case Types.SET_LOADING:
      return {
        ...state,
        loading: true,
      }
    default: return state;
  }
};

export default Domains;
